var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Header, Icon, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
var starterKitPageLinks = [
    {
        title: "RNA CISH Starter Kit",
        description: "Manage RNA CISH starter kit configuration.",
        path: AppPaths.ADMIN_RNA_CISH_STARTER_KIT
    },
    {
        title: "Manual Starter Kit",
        description: "Manage manual starter kit configuration.",
        path: AppPaths.ADMIN_MANUAL_STARTER_KIT
    }
];
var StarterKitsPage = /** @class */ (function (_super) {
    __extends(StarterKitsPage, _super);
    function StarterKitsPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StarterKitsPage.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Starter Kits"),
            React.createElement("div", { id: "non-header-portion" },
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Starter Kit Page"),
                            React.createElement(Table.HeaderCell, null, "Description"),
                            React.createElement(Table.HeaderCell, null, "Open"))),
                    React.createElement(Table.Body, null, starterKitPageLinks.map(function (starterKitPageLink) { return (React.createElement(Table.Row, { key: starterKitPageLink.path },
                        React.createElement(Table.Cell, null,
                            React.createElement(Link, { to: starterKitPageLink.path }, starterKitPageLink.title)),
                        React.createElement(Table.Cell, null, starterKitPageLink.description),
                        React.createElement(Table.Cell, { collapsing: true },
                            React.createElement(Link, { to: starterKitPageLink.path },
                                React.createElement(Icon, { name: "arrow right" }),
                                "Open")))); }))))));
    };
    return StarterKitsPage;
}(React.PureComponent));
export default StarterKitsPage;
//# sourceMappingURL=StarterKitsPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/StarterKitsPage.js
// module id = 1478
// module chunks = 0